export const BANK_MODES = ['BANK', 'IMPS', 'NEFT'];

export const BANK_CODES = {
  UTIB: 'UTIB',
  CITI: 'CITI',
  HDFC: 'HDFC',
  ICIC: 'ICIC',
  IDFB: 'IDFB',
  RBLB: 'RATN',
  KKBK: 'KKBK',
  SBIN: 'SBIN',
  SCBL: 'SCBL',
  YESB: 'YESB',
  INDB: 'INDB',
  CASH: 'CASH',
  PYTM: 'PYTM',
};
